import React from 'react'
import Icon from '../IconV1'
import ModalLink from '../ModalLink'

const Tip = ({ tip, children }) => {
  let modal = tip

  switch (typeof tip) {
    case 'number':
      modal = {
        modal: 'Tooltip',
        data: { tooltipId: tip },
      }
      break

    case 'string':
      modal = { modal: tip }
      break

    //no default
  }

  return (
    <span>
      {children} <ModalLink {...modal} component={Icon} />
    </span>
  )
}

export default Tip
